import ReportNameCellRenderer from "./cell-renderers/report-name.cell-renderer";
import MenuIconCellRenderer from "./cell-renderers/menu-icon.cell-renderer";

class ReportListService {
  static colDefs = [
    { 
      headerName: '', 
      field: 'menu', 
      cellRenderer: MenuIconCellRenderer,
      width: 50
    }, 
    { 
      headerName: 'Report ID', 
      field: 'reportId', 
      hide: true  
    },
    { field: 'bucket', headerName: 'Type', initialWidth: 112 },
    { field: "reportName", flex: 1, cellRenderer: ReportNameCellRenderer, wrapText: true, autoHeight: true },
    { field: "reportDescription" },
    { field: "category" },
    { field: "owner" },   
    { field: "permissions" },
    { field: "formattedModifiedDate" ,headerName:'Modified Date'}
   
  ];
};

export default ReportListService;